<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <img src="../../assets/Personback.png" alt=""
      style="width: .4167rem;height: .1458rem;position: relative; top: .783rem;left: 2.9604rem;"
      @click="$router.go(-1);">
    <Navstudent></Navstudent>
    <div class="t">
      <div class="title">预约辅导</div>
      <div class="line"></div>
      <div style="margin-top:.2604rem ;margin-left: .1042rem;">
        <div class="flex">
          <div class="txt">家长称呼</div>
          <div class="xing">*</div>
          <el-input v-model="parentName" placeholder="请输入"
            :style="{ width: '1.4792rem', height: '.1667rem' }"></el-input>
        </div>
        <div class="flex">
          <div class="txt">联系方式</div>
          <div class="xing">*</div>
          <el-input v-model.lazy="phone" placeholder="请输入微信号或者电话号码" :disabled="truephone != ''"
            :style="{ width: '1.4792rem', height: '.1667rem' }"></el-input>
          <button class="button" v-if="truephone == ''"
            style="margin-left: 0.2rem;margin-top: 0; padding-left:0.05rem;width:  0.45rem;padding-top: 0.05rem;"
            @click="yanzhengma">{{ yanzhengmatext }}</button>
        </div>
        <div class="flex" v-if="truephone == ''">
          <div class="txt">验证码</div>
          <div class="xing">*</div>
          <el-input v-model.lazy="code" placeholder="请输入验证码"
            :style="{ width: '1.4792rem', height: '.1667rem' }"></el-input>
          <button class="button"
            style="margin-left: 0.2rem;margin-top: 0; padding-left:0.15rem;width:  0.45rem;padding-top: 0.05rem;"
            @click="yanzhengmaback">确定</button>
        </div>

        <div class="flex">
          <div class="txt">备注</div>
        </div>
        <div class="flex"><el-input type="textarea" :rows="5" placeholder="请描述一下您的孩子状况，并确认在哪段时间需要老师辅导" v-model="remark">
          </el-input></div>
        <div class="button">
          <button @click="yuyue">确认预约</button>
          <button
            style="color: #606266;background-color: #fff;border: solid 2px rgb(211, 213, 218); ;border-radius:4px">取消</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Navstudent from '../layout/nav-student.vue'

export default {
  components: {
    Navstudent
  },
  data() {
    return {
      parentName: '',
      truephone: '',
      code: '',
      yanzhengmatext: '获取验证码',
      phone: '',
      remark: '',
      location: [{
        value: 0,
        label: '锦江区'
      }, {
        value: 1,
        label: '金牛区'
      }, {
        value: 2,
        label: '武侯区'
      }, {
        value: 3,
        label: '青羊区'
      }, {
        value: 4,
        label: '成华区'
      }, {
        value: 5,
        label: '高新区'
      }, {
        value: 6,
        label: '天府新区'
      }, {
        value: 7,
        label: '新都区'
      }, {
        value: 8,
        label: '郫都区'
      }, {
        value: 9,
        label: '双流区'
      }, {
        value: 10,
        label: '龙泉驿区'
      }, {
        value: 11,
        label: '温江区'
      }, {
        value: 13,
        label: '都江堰'
      }, {
        value: 14,
        label: '彭州'
      }, {
        value: 15,
        label: '邛崃'
      }, {
        value: 16,
        label: '崇州'
      }, {
        value: 17,
        label: '简阳'
      }, {
        value: 18,
        label: '金堂'
      }, {
        value: 19,
        label: '大邑'
      }, {
        value: 20,
        label: '蒲江'
      }, {
        value: 21,
        label: '新津'
      }, {
        value: 22,
        label: '青白江'
      },
      {
        value: 12,
        label: '其他'
      },],
      studyArea: '',
    }
  },
  methods: {
    yanzhengma() {
      if (this.phone == '') {
        this.$message({
          message: '请输入手机号',
          type: 'error'
        });
        return
      }
      let formData = new FormData();
      formData.append('phone', this.phone);

      this.$http.post('/Api/User/User/Web/Phone/Verify', formData, {
        headers: {
          'Authorization': localStorage.getItem('Authorization'),
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        if (res.data.msg == 'SUCCESS') {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          });
        } else {
          this.$message({
            message: '验证码发送失败',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
      });

      this.yanzhengmatext = '60s后获取'
      let time = 60
      let timer = setInterval(() => {
        time--
        this.yanzhengmatext = time + 's后获取'
        if (time == 0) {
          clearInterval(timer)
          this.yanzhengmatext = '获取验证码'
        }
      }, 1000)
    },
    yanzhengmaback() {
      console.log(1);
      let formData = new FormData();
      formData.append('code', this.code);
      if (this.code == '') {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return
      }
      this.$http.post('/Api/User/User/Web/Phone/Verify/Callback', formData,
        {
          headers: {
            'Authorization': localStorage.getItem('Authorization'),
            'Content-Type': 'multipart/form-data'

          }
        },).then(res => {
          console.log(res);
          if (res.data.msg == 'SUCCESS') {
            this.$message({
              message: '验证成功',
              type: 'success'
            });
            localStorage.setItem('phone', this.phone)
          } else {
            this.$message({
              message: '验证失败',
              type: 'error'
            });
          }
        }).catch(err => {
          console.log(err);
        });
    },

    yuyue() {
      if (this.parentName == '' || this.phone == '' || this.remark == '') {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return
      }
      let a = {
        parentName: this.parentName,
        phone: this.phone,
        studyArea: this.studyArea,
        remark: this.remark,
      }
      this.$http.post('/Api/Parent/Contract/' + this.$route.hash.slice(1), JSON.stringify(a), {
        headers: {
          'Authorization': localStorage.getItem('Authorization'),
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log(res);
        if (res.data.msg = 'SUCCESS') {
          this.$router.push('/personstudent/success#2')
        }
        else {
          this.$message({
            message: '预约失败',
            type: 'error'
          });
        }

      }).catch(err => {
        console.log(err);

      })
    }
  },
  created() {
    this.truephone = localStorage.getItem('phone')
    if (localStorage.getItem('phone')) {
      this.truephone = localStorage.getItem('phone')
      this.phone = localStorage.getItem('phone')
    }
    else {
      this.truephone = ''
    }
  }


}
</script>

<style scoped>
.t {
  width: 900px;
  margin: 0 auto;
  padding-left: 125px;
  margin-top: 67px;
}

/deep/ .el-icon-arrow-up:before {
  content: "\E6E1";
  position: relative;
  top: -3px;
}

.button {
  width: 158px;
  height: 32px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.title {
  /* 修改手机号 */
  height: 38px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 36px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;

}

.line {
  /* Line */
  width: 750px;
  height: 2px;
  background: rgb(220, 223, 230);
  margin-top: 16px;
}

.flex {
  display: flex;
  margin-top: 18px;
}

.text {
  /* 当前手机号：182****2222 */
  height: 22px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 550;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
}

.code {
  /* 验证码 */
  width: 150px;
  height: 30px;
  margin-top: 31px;
  margin-left: 10px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  padding-left: 10px;
}

.txt {
  /* 新手机号 */

  width: 56px !important;
  height: 22px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
}

.xing {
  color: rgb(245, 108, 108);
  font-size: 14px;
  font-weight: 600;
  width: 22px;
  text-align: center;
  transform: translateY(8px);
}


button {
  width: 73px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

/deep/ .el-input__inner {
  height: 32px;
}

.other {
  width: 72.92px;
  height: 32px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  /* 取消 */

  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;


}
</style>


// WEBPACK FOOTER //
// src/components/pages/student-yuyue.vue